module.exports = __webpack_public_path__ + "static/media/neteller.83269a31.svg";